import React from "react";
import styled from "styled-components";
import {
  Button as AIMEButton,
  Input as AIMEInput,
} from "tot-loft-component-library";
import StatusBadge from "./StatusBadge";

const normalizeStatus = (status = "") => status.trim().toLowerCase();

const STATUS_COLORS = {
  won: "rgba(18, 124, 78, 0.1)",
  "verbally committed": "rgba(244, 186, 52, 0.1)",
  "proposal sent": "rgba(244, 186, 52, 0.1)",
  lost: "rgba(240, 70, 63, 0.1)",
  "lead identified": "rgba(89, 84, 222, 0.1)",
  opportunity: "rgba(89, 84, 222, 0.1)",
  all: "rgba(100, 116, 139, 0.1)",
};

const STATUS_TEXT_COLORS = {
  won: "rgb(18, 124, 78)",
  "verbally committed": "rgb(244, 186, 52)",
  "proposal sent": "rgb(244, 186, 52)",
  lost: "rgb(240, 70, 63)",
  "lead identified": "rgb(89, 84, 222)",
  opportunity: "rgb(89, 84, 222)",
  all: "rgb(100, 116, 139)",
};

const statusMessages = {
  "Lead Identified": (
    <>
      <strong>Your next step</strong>: Email or call the Referrer directly using the contact details listed below
    </>
  ),
  Opportunity:
    "The vendor has engaged with the end prospective client. Solution in development.Vendor also enters target deal close date.",
  "Proposal Sent": "The vendor has sent a proposal to the prospect.",
  "Verbally Committed":
    "The vendor has reached a verbal agreement with prospects.",
  Won: "The vendor has contracted with the end client and is now onboarding them.",
  Lost: "",
};
const ReferralStatusCard = ({
  status,
  icon,
  note,
  updatedAt,
  onChangeStatus,
  showCustomWon,
  LostReason,
}) => {
  return (
    <StatusBars>
      <Frame1466 status={status}>
        <Frame1468>
          <StatusBadge status={status} showCustomWon={showCustomWon} />

          <Frame1525>
            <LeadIdentified status={status}>{status}</LeadIdentified>
            <TheVendorWillEngageWithTheMemberToLearnMoreContextAboutTheReferralSubmitted>
              {statusMessages[status]}
            </TheVendorWillEngageWithTheMemberToLearnMoreContextAboutTheReferralSubmitted>
            {/* <Frame1437>
              <Note>Note:</Note>
              <LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry>
                {note}
              </LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry>
            </Frame1437> */}
            {status == "Lost" && (
              <ReasonNoFitNotIdealClientProfile>
                <span style={{ fontWeight: 700 }}>Reason:</span> {LostReason}
              </ReasonNoFitNotIdealClientProfile>
            )}
          </Frame1525>
        </Frame1468>
        <Frame1470>
          <UpdatedAt2Apr2025>Updated at: {updatedAt}</UpdatedAt2Apr2025>

          <AIMEButton
            size="small"
            onClick={() => onChangeStatus()}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
              alignItems: "center",
              flex: "none",
              gap: "8px",
              borderRadius: "999px",
              height: "36px",
              background: "rgb(97, 98, 197)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              backgroundPosition: "center",
              boxSizing: "border-box",
              padding: "8px 16px",
            }}
          >
            <span
              style={{
                color: "white",
                textOverflow: "ellipsis",
                fontSize: "14px",
                fontFamily: "Montserrat, sans-serif",
                fontWeight: "600",
                lineHeight: "140%",
                textAlign: "left",
              }}
            >
              Change Status
            </span>
          </AIMEButton>
        </Frame1470>
      </Frame1466>
    </StatusBars>
  );
};

export default ReferralStatusCard;

const StatusBars = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1466 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  border-radius: 16px;
  align-self: stretch;
  background: ${({ status }) => {
    const key = normalizeStatus(status || "all");
    return STATUS_COLORS[key] || "rgba(100, 116, 139, 0.1)";
  }};
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px 24px;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
  }

  @media (max-width: 767px) {
    flex-direction: column;
      align-items: flex-start;
  }
`;

const Frame1468 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 16px;
  width: 824px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame1428 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 4px;
  border-radius: 999px;
  width: 48px;
  height: 48px;
  background: linear-gradient(
    -90deg,
    rgba(89, 84, 222, 0.1),
    rgba(89, 84, 222, 0.1)
  );
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const User = styled.span`
  color: rgb(89, 84, 222);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: "Font Awesome 6 Pro", sans-serif;
  font-weight: 400;
  line-height: 160%;
  text-align: center;
`;

const Frame1525 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  max-width: 760px;
  width: 100%;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const LeadIdentified = styled.span`
  color: ${({ status }) => {
    const normalized = normalizeStatus(status || "all");
    return STATUS_TEXT_COLORS[normalized] || "rgb(100, 116, 139)";
  }};
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  line-height: 160%;
  text-align: left;
`;

const TheVendorWillEngageWithTheMemberToLearnMoreContextAboutTheReferralSubmitted = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1437 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Note = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  line-height: 160%;
  text-align: left;
`;

const LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;

  flex: 1;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const ReasonNoFitNotIdealClientProfile = styled.span`
  color: rgb(240, 70, 63);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Frame1470 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
  flex-wrap: wrap;
  @media (max-width: 1024px) and (min-width: 768px) {
  }

  @media (max-width: 767px) {
    justify-content: flex-start;
  }
`;

const UpdatedAt2Apr2025 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;
